var _g, _circle, _line, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTobacco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 615,
    height: 615,
    viewBox: "0 0 615 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.5 358L390.25 358V412.75L116.5 412.75L116.5 358ZM454.125 358H481.5V412.75H454.125V358ZM408.5 358H435.875V412.75H408.5V358ZM424.013 207.073C435.328 195.94 442.263 180.61 442.263 163.637C442.263 129.875 414.888 102.5 381.125 102.5V129.875C399.74 129.875 414.888 145.022 414.888 163.637C414.888 182.252 399.74 197.4 381.125 197.4V224.775C422.005 224.775 454.125 258.173 454.125 299.053V339.75H481.5V298.87C481.5 258.355 458.14 223.315 424.013 207.073ZM372.548 252.15H344.625C326.01 252.15 310.862 234.265 310.862 215.65C310.862 197.035 326.01 183.712 344.625 183.712V156.337C310.863 156.337 283.487 183.713 283.487 217.475C283.487 251.238 310.863 278.612 344.625 278.612H372.548C391.71 278.612 408.5 292.117 408.5 316.025V339.75H435.875V309.82C435.875 276.787 406.675 252.15 372.548 252.15Z",
    fill: "#FCFCFC"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 307.5,
    cy: 307.5,
    r: 293.5,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 103.636,
    y1: 83.8366,
    x2: 532.04,
    y2: 512.241,
    stroke: "#FCFCFC",
    strokeWidth: 28
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 438,
    height: 438,
    fill: "white",
    transform: "translate(80 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTobacco);
export default __webpack_public_path__ + "static/media/tobacco.c7937ceedb2aa467101dca54f4582533.svg";
export { ForwardRef as ReactComponent };